import React, { SyntheticEvent, useContext, useState } from 'react';
import { GalleriaRefContext } from '../../contexts/GalleriaRefContext';
import PropertyGalleria from '../property-detail-page/PropertyGalleria';
import placeholder from 'images/placeholder.webp';
import { Image } from '../../utility/types';

type GridImageViewerProps = {
  propertyImages: Image[];
};

export const GridImageViewer = ({ propertyImages }: GridImageViewerProps) => {
  const galleriaRef = useContext(GalleriaRefContext);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);

  const images = propertyImages.map((image, index) => {
    const shouldSpanTwoRows =
      index % 5 === 0 ||
      (index === propertyImages.length - 1 &&
        (index % 5 === 1 || index % 5 === 3));

    const imageStyle = shouldSpanTwoRows ? 'row-span-2' : '';

    return (
      <div className={`${imageStyle} relative`} key={index}>
        <img
          className="h-full"
          src={image.image_url}
          alt="Property Images"
          onError={(e: SyntheticEvent<HTMLImageElement, Event>) => {
            const target = e.target as HTMLImageElement;
            target.src = placeholder;
          }}
          onClick={() => {
            galleriaRef.current.show();
            setSelectedPhotoIndex(index);
          }}
        />
        {image?.date && (
          <p
            className={
              'absolute bottom-5 right-5 text-xl text-white bg-slate-700/60'
            }
          >
            {image.date}
          </p>
        )}
      </div>
    );
  });

  return (
    <div
      className={`h-full grid grid-rows-2 auto-cols-max grid-flow-col overflow-x-auto gap-4 ${
        propertyImages.length === 1 ? 'justify-center' : ''
      }`}
    >
      {images}
      <PropertyGalleria
        ref={galleriaRef}
        activeIndex={selectedPhotoIndex}
        propertyImages={propertyImages}
      />
    </div>
  );
};
